import { AsyncPipe, NgForOf } from '@angular/common';
import { ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { FormlySelectModule } from '@ngx-formly/core/select';
import { FormFieldModule } from '../wrapper/form-field/form-field.component';
import { CyTestDirective } from '@portal/directive';
import { PortalFieldTypeConfig } from '@portal/form/data-access';

@Component({
  selector: 'portal-form-checkbox',
  standalone: true,
  imports: [NgForOf, AsyncPipe, FormlyModule, FormlySelectModule, MatCheckboxModule, CyTestDirective],
  template: `
    <ng-container *ngFor="let option of props.options | formlySelectOptions: field | async; let i = index">
      <mat-checkbox
        [id]="id + '_' + i"
        class="field-checkbox"
        [portalCyTest]="field.key"
        [formlyAttributes]="field"
        [tabIndex]="props.tabindex"
        [color]="defaultOptions.props.color"
        [labelPosition]="defaultOptions.props.labelPosition"
        [checked]="isChecked(option)"
        [disabled]="disabled || option.disabled"
        (change)="onChange(option.value, $event.checked)"
        >{{ option.label }}
      </mat-checkbox>
    </ng-container>
  `,
  styles: [
    `
      :host {
        @apply flex flex-col items-start gap-2 mt-2;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxComponent extends FieldType<PortalFieldTypeConfig> {
  override defaultOptions = { props: { color: 'primary' as const, labelPosition: 'after' as const } };

  /**
   * Check if form or field is disabled
   * @returns boolean
   * @readonly
   */
  get disabled(): boolean {
    return !!this.options?.formState?.disabled || !!this.props?.disabled;
  }

  onChange(value: any, checked: boolean): void {
    this.formControl.markAsDirty();
    if (this.props.type === 'array') {
      this.formControl.patchValue(
        checked ? [...(this.formControl.value || []), value] : [...(this.formControl.value || [])].filter(o => o !== value),
      );
    } else {
      this.formControl.patchValue({ ...this.formControl.value, [value]: checked });
    }
    this.formControl.markAsTouched();
  }

  isChecked(option: any): boolean {
    const value = this.formControl.value;
    return value && (this.props.type === 'array' ? value.indexOf(option.value) !== -1 : value[option.value]);
  }
}

@NgModule({
  imports: [
    FormFieldModule,
    FormlyModule.forChild({
      types: [{ name: 'checkbox', component: CheckboxComponent, wrappers: ['form-field'] }],
    }),
  ],
})
export class FormCheckboxModule {}
